<template>
  <v-container class="py-12">
    <div class="text-center">
      <h1 class="text-h4 text-sm-h3">Condorcet Jobs</h1>

      <div class="subtitle-1 text--secondary mt-2">
        La Haute Ecole est régulièrement à la recherche de nouveaux collaborateurs.
        <br>
        Vous avez des savoirs et une expérience à apporter ? Alors, rejoignez-nous !
      </div>

      <v-img
        height="200"
        class="mt-6 mb-12"
        contain
        :src="require('@/assets/undraw_interview_rmcf.svg')"
      ></v-img>

      <v-btn
        color="primary"
        to="vacant-jobs"
        class="pa-6"
      >
        Emplois vacants
      </v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
};
</script>
